import { createAction } from 'redux-act';

export const setBusinessPartnerID = createAction('Set business partner id');
export const sapAuthentication = createAction('Set SAP authentication');
